import { FrequencyDocument } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { FrequencyDocumentService } from "@/services/frequency-document-service";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";

export class FrequencyDocumentEditState extends SaleEditState {
	doc:FrequencyDocument = new FrequencyDocument();

	public async save():Promise<boolean> {
		if (!this.doc.Sale) return false;
		this.doc.Sale.calculateTotals();
		this.doc.Sale.BookYear = 0;

		this.doc.Sale.Rows.forEach(row => {
			if (!this.doc.Sale) return;
			if (this.doc.Sale.ID)
				row.SaleID = this.doc.Sale.ID;
			row.BookYear = 0;
		});

		if (this.doc.ID == 0) {
			var doc = await FrequencyDocumentService.postDoc(this.doc);
		} else {
			var doc = await FrequencyDocumentService.putDoc(this.doc);
		}
		this.doc = await FrequencyDocumentService.getDocument(doc.ID);
		this.vue.$wf.notify(this.vue.$t("common.success").toString(), "success", 3000, "check");
		this.emit("saved", this.doc);
		return true;
	}

	public setToPrintMessage(override:boolean = false){
		if (!this.doc.SaleTypeID) return;
		if (this.sale.ToPrintMessage == "" || override) {
			this.sale.ToPrintMessage = DossierConfigService.getSaleConfig(this.doc.SaleTypeID).DefaultComment.getTranslation(this.sale.getLng());
		}
	}

}